import { cn } from '@/lib/utils';
import Dot from '@/components/ui/Dot.tsx';
import { AcceptanceDocumentVm } from '@/features/dashboard/bookingChanges/types/ChangePackageFlowViewModel.ts';
import { PREVIEW_ONLY_TITLE } from './clientAcceptanceCopy.ts';

interface ClientAcceptanceDocumentRowProps
  extends React.HTMLAttributes<HTMLDivElement> {
  document: AcceptanceDocumentVm;
}

/** Wiersz dokumentu do podpisu: nazwa i wygaszony podgląd. */
const ClientAcceptanceDocumentRow = ({
  document,
  className,
  ...props
}: ClientAcceptanceDocumentRowProps) => (
  <div
    className={cn('flex items-start gap-[11px] py-2.5', className)}
    {...props}
  >
    <Dot size="sm" className="mt-1.5" />
    <span className="min-w-0 text-[15px] font-semibold text-ink">
      {document.name}
    </span>
    <button
      type="button"
      disabled
      title={PREVIEW_ONLY_TITLE}
      className="ml-auto shrink-0 cursor-not-allowed text-sm font-semibold text-info-300"
    >
      Podgląd
    </button>
  </div>
);

export default ClientAcceptanceDocumentRow;
